module.exports = "../dist/img/product-card-29.1e86.jpg";